import { useEffect, useRef } from "react";

/**
 * Closes a popover on outside click or Escape.
 * Returns the ref that must be attached to the popover wrapper.
 */
export function useDismiss<T extends HTMLElement = HTMLDivElement>(
    open: boolean,
    onDismiss: () => void,
) {
    const ref = useRef<T>(null);

    useEffect(() => {
        if (!open) return;

        const handlePointerDown = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                onDismiss();
            }
        };

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") onDismiss();
        };

        document.addEventListener("mousedown", handlePointerDown);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("mousedown", handlePointerDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [open, onDismiss]);

    return ref;
}
